import {
  getSystemDocumentBqId,
  type SystemDocumentEntry,
} from 'features/knowledgeDocumentViewer/types/systemDocumentEntries'

/**
 * The BQ `document_id` for a system-document. Newer ingests carry it in
 * `data.document_id`; older ones leave that null but keep the same id
 * reachable via `data.source_document_id` or the entry id itself, which is
 * the BQ id plus a config-hash suffix.
 */
export function resolveBqDocumentId(
  entry: SystemDocumentEntry | undefined
): string | undefined {
  if (!entry) return undefined
  const fromField = getSystemDocumentBqId(entry)
  if (fromField) return fromField

  const source = (entry.entry.data as { source_document_id?: unknown })
    .source_document_id
  if (typeof source === 'string' && source.length > 0) return source

  const match = /^(DOC-[0-9a-f]+)_[0-9a-f]+$/.exec(entry.entry.id)
  return match ? match[1] : undefined
}

export function bqPageId(bqDocumentId: string, pageNumber: number): string {
  return `${bqDocumentId}_pg_${pageNumber}`
}
